import apiClient from '../client';

/** The store's automatic offers (Buy X Get Y) for badges and banners. [] when there are none. */
export const getActiveOffers = async (marketCode) => {
  const { data } = await apiClient.get('/offers/active', { params: marketCode ? { marketCode } : {} });
  return Array.isArray(data) ? data : [];
};
